import { PolicyPresetType } from "../edc-demo/models/policy-preset-type"

// NOTE: EDC 0.17.0 validates the raw policy JSON against a JSON Schema
// (management-api-schema-validator -> dspace contract-schema) BEFORE JSON-LD expansion.
// That schema requires:
//   - "constraint" to be an ARRAY of constraints
//   - "operator" to be a BARE enum string ("eq","gteq","lteq",...) — NOT "odrl:eq" and NOT {"@id":"odrl:eq"}
//   - the property key "leftOperand" (not "odrl:leftOperand")
// See src/edc-connector/extensions/policy-engine for the matching evaluation keys.

export const LOCATION_PRESET: PolicyPresetType = {
    id: 'location',
    name: 'Location',
    odrlJsonString:
    `
    {
        "action": "use",
        "constraint": [
            {
                "leftOperand": "https://w3id.org/edc/v0.0.1/ns/regionLocation",
                "operator": "eq",
                "rightOperand": "{{location}}"
            }
        ]
    }
    `
}

export const PURPOSE_PRESET: PolicyPresetType = {
    id: 'purpose',
    name: 'Purpose',
    odrlJsonString:
    `
    {
        "action": "use",
        "constraint": [
            {
                "leftOperand": "https://w3id.org/edc/v0.0.1/ns/purpose",
                "operator": "eq",
                "rightOperand": "{{purpose}}"
            }
        ]
    }
    `
}

// Time format is yyyy-mm-ddThh:mm:ss.sssZ (UTC)
export const TIME_INTERVAL_PRESET: PolicyPresetType = {
    id: 'timeinterval',
    name: 'Time interval',
    odrlJsonString:
    `
    {
        "action": "use",
        "constraint": [
            {
                "leftOperand": "https://w3id.org/edc/v0.0.1/ns/timeInterval",
                "operator": "gteq",
                "rightOperand": {
                    "@type": "xsd:date",
                    "@value": "{{timeFrom}}"
                }
            },
            {
                "leftOperand": "https://w3id.org/edc/v0.0.1/ns/timeInterval",
                "operator": "lteq",
                "rightOperand": {
                    "@type": "xsd:date",
                    "@value": "{{timeTo}}"
                }
            }
        ]
    }
    `
}

export const CUSTOM_PRESET: PolicyPresetType = {
    id: 'custom',
    name: 'Custom',
    odrlJsonString: "{}"
}
